import React, {useState, useEffect} from 'react';
import './SupplierStyle.css';

const UpdateProductBySupplier = ({product, handleCloseUpdate}) =>{

    const [productName, setProductName]=useState('');
    const [productDescription, setProductDescription]=useState('');
    const [productQuantity, setProductQuantity]=useState('');
    const [productType, setProductType]=useState('');
    const [date, setDate]=useState('');

    useEffect(()=>{
        setProductName(product.productName);
        setProductDescription(product.productDescription);
        setProductQuantity(product.productQuantity);
        setProductType(product.productType);
        setDate(product.date);
    },[product]);

    const HandleSubmit = (e) => {
        e.preventDefault();
        handleCloseUpdate(product.productId, {productName, productDescription, productQuantity, productType, date});
    };

    return(
        
        <div className="container-fluid add-product-page">
            <div className="row">
                <div className="col-md-6 p-3 mx-auto shadow add-product-form">
                    <form onSubmit={HandleSubmit}>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Product Name"
                                value={productName}
                                onChange={(e)=> setProductName(e.target.value)}
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Product Description"
                                value={productDescription}
                                onChange={(e)=>setProductDescription(e.target.value)}
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="number"
                                placeholder="Quantity"
                                value={productQuantity}
                                onChange={(e)=>setProductQuantity(e.target.value)}
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="text"
                                placeholder="Product Type"
                                value={productType}
                                onChange={(e)=>setProductType(e.target.value)}
                            />
                        </div>
                        <div className="form-group my-3">
                            <input
                                className="form-control"
                                type="date"
                                placeholder="Date"
                                value={date}
                                onChange={(e)=>setDate(e.target.value)}
                            />
                        </div>
                        <div className='add-product-buttons'>
                            <div className="form-group my-3 ">
                                <button type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default UpdateProductBySupplier;